export default "__VITE_ASSET__BukPWX4i__"